import { SECTION_LABELS } from '@common/configs';

export const formatSectionId = (id: string): string => {
  if (!id) {
    return '';
  }

  const specialCases = ['CTR', 'CPC', 'TKP', 'CPM', 'CPE'];

  const capitalized = id
    .split('_')
    .map((word) => {
      if (specialCases.includes(word.toUpperCase())) {
        return word.toUpperCase();
      }
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');

  const key = id.toLowerCase();
  return SECTION_LABELS[key] || capitalized;
};
